// import "./frappe-chart"
frappe.provide('frappe.ui.form')
console.log("Scripts from site.bundle.js loaded");

// check if param not contain '_lang', add it to the url with value 'en'
export function addLangParamToUrl() {
  console.log("Checking URL for _lang parameter");
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('_lang')) {
    urlParams.set('_lang', 'en');
    window.location.search = urlParams.toString();
  }
}

addLangParamToUrl();


document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded and parsed");
  
  document.addEventListener("click", function(e) {
    let target = e.target.closest("a[href^='/job_application/new']");
    
    if (target) {
      e.preventDefault();
      let targetHref = target.getAttribute("href");
      let accepted = window.localStorage.getItem("accepted_terms");
      
      if (accepted === "yes") {
        window.location.href = targetHref;
      } else {
        showTermsDialog(targetHref);
      }
    }
  }, true);
  
  function showTermsDialog(redirectUrl) {
    frappe.msgprint({
      title: __("THÔNG BÁO VỀ VIỆC XỬ LÝ DỮ LIỆU CÁ NHÂN"),
      indicator: 'blue',
      message: `
        <div style="margin-bottom: 15px;">
          <p>Vui lòng đọc và chấp nhận điều khoản trước khi tiếp tục:</p>
        </div>
        <div>
          <iframe src="https://drive.google.com/file/d/1oF8DbH9-uw5aGPXYj_6TZabbKc-PGTaT/preview" 
                  width="100%" 
                  height="600" 
                  style="border:none; background-color: white;">
          </iframe>
        </div>
        <div style="margin-top: 15px; text-align: right;">
          <button class="btn btn-secondary btn-sm" onclick="frappe.hide_msgprint()">Huỷ</button>
          <button class="btn btn-primary btn-sm" onclick="acceptTerms('${redirectUrl}')">Đã đọc và Đồng ý</button>
        </div>
      `
    });
    
    // Tăng kích thước modal sau khi hiển thị
    setTimeout(function() {
      let modal = document.querySelector('.msgprint-dialog.modal-dialog');
      if (modal) {
        modal.style.maxWidth = '750px';
        modal.style.width = '750px';
      }
      
      let modalBody = document.querySelector('.msgprint-dialog .modal-body');
      if (modalBody) {
        modalBody.style.maxHeight = '80vh';
        modalBody.style.overflow = 'auto';
      }
    }, 300);
  }
  
  window.acceptTerms = function(url) {
    window.localStorage.setItem("accepted_terms", "yes");
    frappe.hide_msgprint();
    window.location.href = url;
  }
});

